import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { PreparationHDModel } from 'src/app/models/PreparationHDModel';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';         ///----------- for searching pop up -----------
import { formatDate } from '@angular/common';
import { StockTrnHDModel } from 'src/app/models/StockTrnModel';
import { StockTrnService } from 'src/app/services/StockTrnService';
import { SuppliesService } from 'src/app/services/SuppliesService';
import { SuppliesModel } from 'src/app/models/SuppliesModel';

@Component({
  selector: 'app-invoice-search',
  templateUrl: './invoice-search.component.html',
  styleUrls: ['./invoice-search.component.css']
})
export class InvoiceSearchComponent implements OnInit {
  hedtype = '21' ;
  hedserial = '' ;
  heddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  hedsup_client = '' ;
  hedroomnumber = '' ;
  hedprogramno = '' ;
  hedtax1 = '' ;
  hedtax2 = '' ;
  heddisc1 = 0 ;
  heddisc2 = 0 ;
  hedstore = '' ;
  hedtostore = '' ;
  heddoctor = '' ;
  heddescription = '' ;
  hedpost = '' ;
  compcode = '1' ;
  userid = '' ;
  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  patientName = '';
  wk_Title = 'Patient';
  stocktrnhdList: StockTrnHDModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();


  constructor(public dialogRef: MatDialogRef<InvoiceSearchComponent>,   ///----------- for searching pop up -----------
  public stocktrnservice: StockTrnService,
  public stocktrnhd: StockTrnHDModel,
  public suppliesService : SuppliesService,
  public storage: LocalStorageService,
  @Inject(MAT_DIALOG_DATA)  public data: any,                                   ///----------- for searching pop up -----------
  public stocktrnhdSelectedData: StockTrnHDModel) {
    this.hedtype = data.hedtype
   }

  ngOnInit(): void {
    this.retriveTransTop();
    if ( this.hedtype == '11' || this.hedtype == '22' ){
      this.wk_Title = 'Supplier'
    }
  }
  retriveTransTop(){

    this.stocktrnservice.StockTrnHDLookupToop(this.hedtype,this.storage.retrieve('stgcompCode')).subscribe((data: StockTrnHDModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.stocktrnhdList[i] = data[i];
        this.stocktrnhdList[i].heddate = formatDate(data[i].heddate, 'yyyy/MM/dd', 'en');

        if ( this.hedtype == '11' || this.hedtype == '22' ){
          this.suppliesService.getsupplies(this.stocktrnhdList[i].hedsup_client,this.storage.retrieve('stgcompCode')).subscribe((data : SuppliesModel) => {
            this.stocktrnhdList[i].patientName = data.supName;

          })
        }
      }
    })

  }
  retriveIPrepLookUp(){
    debugger;
    this.stocktrnservice.GetStockTrnHDLookup(this.hedtype,this.hedserial.toString(),this.patientName, this.storage.retrieve('stgcompCode')).subscribe((data: StockTrnHDModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.stocktrnhdList[i] = data[i];
        this.stocktrnhdList[i].heddate = formatDate(data[i].heddate, 'yyyy/MM/dd', 'en');

      }
    })

  }
  SelectItem(pro : StockTrnHDModel){
    this.stocktrnhdSelectedData.hedserial = pro.hedserial


    this.submitClicked.emit(this.stocktrnhdSelectedData);
    this.dialogRef.close();
  }
}
